import { Link } from "react-router-dom";

/**
 * SmsConsentCheckbox — A2P 10DLC compliant SMS opt-in checkbox.
 * Unchecked by default. Required by default (form cannot submit without it
 * when a phone number is supplied). Includes all disclosures required by
 * Zoom / 10DLC carrier reviewers.
 */
export function SmsConsentCheckbox({
  checked,
  onChange,
  required = true,
  testId = "sms-consent-checkbox",
}) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none">
      <input
        type="checkbox"
        data-testid={testId}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
        className="mt-1 w-4 h-4 rounded border-[#EAE3D2] text-[#E9610E] focus:ring-2 focus:ring-[#E9610E]/30 accent-[#E9610E] shrink-0"
      />
      <span className="text-xs text-[#475569] leading-relaxed">
        <strong className="text-[#0F1E3C]">I agree</strong> to receive SMS communications from
        <strong className="text-[#0F1E3C]"> Albany Staffing</strong> (a DBA of Albany Systems LLC)
        regarding job opportunities, interview scheduling, application updates, appointment
        reminders, and recruiting-related communications.{" "}
        <span className="text-[#334155]">
          Message and data rates may apply. Message frequency may vary. Reply{" "}
          <strong className="text-[#0F1E3C]">STOP</strong> to opt out or{" "}
          <strong className="text-[#0F1E3C]">HELP</strong> for assistance.
        </span>{" "}
        See our{" "}
        <Link
          to="/sms-terms"
          className="text-[#E9610E] underline hover:text-[#0F1E3C]"
          onClick={(e) => e.stopPropagation()}
        >
          SMS Terms
        </Link>{" "}
        and{" "}
        <Link
          to="/privacy"
          className="text-[#E9610E] underline hover:text-[#0F1E3C]"
          onClick={(e) => e.stopPropagation()}
        >
          Privacy Policy
        </Link>
        . SMS consent is not shared with third parties or affiliates for marketing purposes.
      </span>
    </label>
  );
}
